module.exports = __webpack_public_path__ + "img/IMG_9056-1200w.cfcda72b.jpg";